// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608060341/js/" + chunkId + "." + {"44":"411d808c","225":"2c0b56a2","481":"daa73634","486":"51038e78","770":"b724f7e8"}[chunkId] + ".0.6140149286326878.chunk.js";
};